<template>
  <div id="app">
	<nav-f></nav-f>  
    <router-view /> <!-- 替换原有Index组件 -->
  </div>
</template>

<script>
import navF from './components/navF'
export default {
  name: 'app',
  components: {
    navF
  }
}
</script>


